/* import __COLOCATED_TEMPLATE__ from './push-data-to-zendesk.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';

interface Args {
  hideBorder?: boolean;
  isSettingsPage?: boolean;
  isMessengerPage?: boolean;
}

export default class StandaloneZendeskSettingsPushDataToZendesk extends Component<Args> {
  @service declare router: RouterService;

  get workflowUrl() {
    return this.args.isMessengerPage
      ? this.router.urlFor('apps.app.standalone.deploy.zendesk.messaging.workflow')
      : this.router.urlFor('apps.app.standalone.deploy.zendesk.tickets.workflow');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Zendesk::Settings::PushDataToZendesk': typeof StandaloneZendeskSettingsPushDataToZendesk;
    'standalone/zendesk/settings/push-data-to-zendesk': typeof StandaloneZendeskSettingsPushDataToZendesk;
  }
}
